// extracted by mini-css-extract-plugin
export default {"content":"NextNewLoading_content__DdXPd","title":"NextNewLoading_title__blSkV","detail":"NextNewLoading_detail__OkaGm"};